<box-loader *ngIf="showLoader" [@fadeInOut]></box-loader>
<router-outlet></router-outlet>
<notifications></notifications>
